module.exports = __webpack_public_path__ + "static/img/2.a7aa7c4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.jpeg
// module id = MvTv
// module chunks = 45